import React from 'react';
import { Clock } from 'lucide-react';
import { RoutineLiveDemo } from './RoutineLiveDemo';

/**
 * Seção própria para Rotinas e Alarmes (antes um card dentro de um grid
 * genérico). Fundo com grade de pontos + brilho azul no canto — remete a um
 * calendário/planner, identidade visual específica desta seção.
 */
const RoutinesSpotlightSection = () => {
  return (
    <section className="relative py-20 md:py-28 bg-muted/30 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.35] dark:opacity-[0.12]"
        style={{
          backgroundImage: 'radial-gradient(rgb(var(--primary)) 1px, transparent 1px)',
          backgroundSize: '26px 26px',
        }}
        aria-hidden="true"
      />
      <div
        className="absolute -top-24 -right-24 w-80 h-80 rounded-full opacity-30 blur-3xl pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgb(var(--primary)) 0%, transparent 70%)' }}
        aria-hidden="true"
      />

      <div className="relative container mx-auto px-6 lg:px-16 xl:px-24 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-flex items-center gap-2 bg-primary/10 dark:bg-primary/15 px-3 py-1.5 rounded-full text-sm font-semibold text-foreground mb-5">
            <Clock className="w-4 h-4 text-primary-ink dark:text-primary-tint" />
            Rotinas e Alarmes
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground">
            Organize o dia com <span className="text-primary-ink dark:text-primary-tint">previsibilidade</span>
          </h2>
          <p className="font-body text-lg text-muted-foreground mt-4 max-w-md">
            Alarmes, checklists visuais e uma rotina clara para reduzir a ansiedade do dia a dia.
          </p>
        </div>

        <div className="w-full max-w-sm mx-auto">
          <RoutineLiveDemo />
        </div>
      </div>
    </section>
  );
};

export default RoutinesSpotlightSection;
